import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { Player } from "@lottiefiles/react-lottie-player";
import animationData from "../../assets/images/bearExplanation/scroll.json";
import DOMPurify from "dompurify";
import "./bearExplanation.sass";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom"; // 引入 useNavigate
import pic01 from "../../assets/images/bearExplanation/pic01.png";
import pic02 from "../../assets/images/bearExplanation/pic02.png";
import pic03 from "../../assets/images/bearExplanation/pic03.png";
import picZh04 from "../../assets/images/bearExplanation/pic_zh04.png";
import picCn04 from "../../assets/images/bearExplanation/pic_cn04.png";
import picEn04 from "../../assets/images/bearExplanation/pic_en04.png";
import picJp04 from "../../assets/images/bearExplanation/pic_jp04.png";
import { ReactComponent as BtnSVG } from "../../assets/images/bearExplanation/btn.svg";
import usePage from "../../hooks/usePage";

export default function Home() {
  const { i18n, t } = useTranslation();
  let navigate = useNavigate(); // 使用 useNavigate 鈎子來獲得 navigate 函數
  const statusData = useSelector((state) => state.user.statusData);
  const scrollBoxRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);

  const pic04 =
    i18n.language === "zh"
      ? picZh04
      : i18n.language === "cn"
        ? picCn04
        : i18n.language === "en"
          ? picEn04
          : picJp04;
  const pics = [pic01, pic02, pic03, pic04];
  usePage({});

  const routeTo = () => {
    // 判斷statusData裡頭的bear_type是否有值，如果有值就導向"myBear"，否則導向"/bearSelection"
    if (statusData.bear_type) {
      navigate("/myBear");
    } else {
      navigate("/bearSelection");
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset + window.innerHeight;
      const fadeOutPosition = document.documentElement.offsetHeight * 0.9;

      if (scrollPosition > fadeOutPosition) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <article className="bear-explanation">
      <div
        ref={scrollBoxRef}
        className={`scroll-box ${!isVisible ? "fade-out" : ""}`}
      >
        <div className="lottie">
          <Player
            autoplay
            loop
            src={animationData}
            style={{ height: "100%", width: "100%" }}
          ></Player>
        </div>
        <p
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(t("bearExplanation.scroll")),
          }}
        ></p>
      </div>
      <section>
        <div className="wrapper">
          <div className="main">
            <div className="title-box">
              <div className="bg">
                <h1>{t("bearExplanation.title")}</h1>
              </div>
            </div>
            <div className="remind-box">
              <p>{t("bearExplanation.remind")}</p>
            </div>
            <div className="step-box">
              {t("bearExplanation.step", { returnObjects: true }).map(
                (step, index) => (
                  <div className="item" key={index}>
                    <figure className="pic">
                      <img src={pics[index]} alt="" />
                    </figure>
                    <div className="info-box">
                      <div className="bg"></div>
                      <div className="step-title">{step.title}</div>
                      <div
                        className="step-content"
                        dangerouslySetInnerHTML={{
                          __html: DOMPurify.sanitize(step.content),
                        }}
                      ></div>
                    </div>
                  </div>
                ),
              )}
            </div>
            <div className="btn-box" onClick={routeTo}>
              <div className="btn-txt">{t("bearExplanation.btnTxt")}</div>
              <BtnSVG />
            </div>
          </div>
        </div>
      </section>
    </article>
  );
}
